import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Card } from '@deckplan.io/common/cards';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventoryCard, Query } from '@deckplan.io/common';

@Component({
    selector: 'app-card-picker',
    templateUrl: './card-picker.component.html',
    styleUrls: ['./card-picker.component.scss']
})
export class CardPickerComponent {

    @Output() public rowClicked = new EventEmitter<Card | InventoryCard>();

    public query: Query;
    public overrideRowClicked = false;
    public searchInventory = false;

    constructor(private readonly dialogRef: MatDialogRef<CardPickerComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data && (data.hasOwnProperty('dataField') || data.hasOwnProperty('operands'))) {
            this.query = data;
        } else if (data && data.hasOwnProperty('query')) {
            this.query = data.query;
            delete data.query;
        }

        this.overrideRowClicked = this.data && this.data.hasOwnProperty('override') && this.data.override;

        this.searchInventory = this.data && this.data.hasOwnProperty('searchInventory') && this.data.searchInventory;
    }

    public onRowClicked(card: Card | InventoryCard) {
        if (this.overrideRowClicked) {
            this.rowClicked.emit(card);
            this.dialogRef.close(card);
        }
    }

    public close() {
        this.dialogRef.close();
    }

}
